var map = {
	"./architect.svg": 32035,
	"./arrow-back.svg": 12967,
	"./configurazioni.svg": 82859,
	"./importo-da-depositare.svg": 53465,
	"./importo-da-sbloccare.svg": 96815,
	"./importo-erogato.svg": 36440,
	"./importo-in-attesa.svg": 975,
	"./login.svg": 51853,
	"./logo-newarc.png": 10520,
	"./logout.svg": 75044,
	"./payment-plan.svg": 80448,
	"./ping.svg": 83038,
	"./placeholder-logo.png": 36255,
	"./placeholder-logo.svg": 57891,
	"./placeholder-user.jpg": 78195,
	"./placeholder.jpg": 2343,
	"./placeholder.svg": 47085,
	"./planimetria.svg": 51566,
	"./preventivi.svg": 65666,
	"./profilo.svg": 72015,
	"./project.svg": 13209,
	"./quotation.svg": 49292,
	"./render.svg": 95834,
	"./ristrutturazione-completa.svg": 53856,
	"./ristrutturazioni.svg": 54556,
	"./saved-houses.svg": 39059,
	"./segnala.svg": 89583,
	"./valutazioni.svg": 26190,
	"./videocall.svg": 88575,
	"./worksite-updates.svg": 86969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32132;